import { Pipe, PipeTransform } from '@angular/core';
import { CommonMethods } from '@services/common.method';
import memo from 'memo-decorator'
import { isNullOrUndefined } from 'util';

@Pipe({ name: 'appointmentstate' })
export class AppointmentStatePipe implements PipeTransform {

  constructor(public commonMethods: CommonMethods) { }
  @memo()
  transform(id: string, type: string): string {
    let CodeTypeData = this.commonMethods.getCompany().CodeTypeData;

    if (type == "state") {
      let status = CodeTypeData.WorkTicketStatus.find(x => x.ID == id);
      if (!isNullOrUndefined(status))
        return status.Name;
    }
    
    if (type == "substate") {
      let subStatus = CodeTypeData.WorkTicketSubStatus.find(x => x.ID == id);
      if (!isNullOrUndefined(subStatus))
        return subStatus.Name;
    }

    return '';
  }
}
